import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestedBatches(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_harvested_batches/${packing_house_process_id}`
    );
  },
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/process/list_harvested_batches/packing_house_process/${packing_house_process_id}`
    );
  },
  fetchExporterQualityTemplates(packing_house_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_containers/list_quality_templates/${packing_house_process_id}`
    );
  },
};
